/**
 * What the four Communication tabs share (Wave 15E split `Comms.tsx` per tab).
 */

import type { Audience, DeliveryRecord, ReminderRecord, Vocabulary } from '../../lib/api/comms'

/** Run a write, say `said` when it worked, and reload every tab. A failure is
 *  shown at the top of the page in the firm's words. */
export type Act = (run: () => Promise<unknown>, said?: string) => Promise<void>

export function audienceLabel(code: Audience, vocab: Vocabulary | null): string {
  return vocab?.audiences.find((a) => a.code === code)?.label ?? code
}

export const SUBJECT_LABELS: Record<ReminderRecord['subject_kind'], string> = {
  case: 'A due date',
  document_request: 'A document we are waiting for',
  invoice: 'An unpaid invoice',
}

export const SOURCE_LABELS: Record<DeliveryRecord['source_kind'], string> = {
  binding: 'Something happened',
  reminder: 'A reminder rule',
  manual: 'Sent by hand',
}
